/* eslint-disable import/no-unresolved,import/extensions */
// @flow
// $FlowFixMe - TS file
import { GeneralLedger } from 'general-ledger';
// $FlowFixMe - TS file
import { NewGeneralLedgerContainer } from 'general-ledger/fast-gl/NewGeneralLedgerContainer';
import { parse, stringify } from 'query-string';
import React from 'react';
// $FlowFixMe - TS file
import { ReviewTool } from 'review-tool';
import { Redirect, Route, Switch } from 'react-router-dom';
import BalanceCheckerView from 'app-client/page/balance-checker';
import BalanceSheetView from 'app-client/page/balance-sheet';
import DocumentEntryView from 'app-client/page/document-entry';
import DownloadView from 'app-client/page/download';
import ExcelDocumentsView from 'app-client/page/excel-documents';
import ImportExcelView from 'app-client/page/import-excel';
import IncomeStatementView from 'app-client/page/income-statement';
import ReconciliationView from 'app-client/page/reconciliation';
import SearchView from 'app-client/page/search';
import TransactionsView from 'app-client/page/transactions';
import UnmatchedReceiptsView from 'app-client/page/unmatched-receipts';
import UnmatchedReceiptsSearchView from 'app-client/page/unmatched-receipts-search';
import UploadView from 'app-client/page/upload';
import { TransactionManager } from './transaction-manager';
// $FlowFixMe - TS file
import { AIAssistant } from './ai-assistant';
import { LedgerAccounts } from './ledger-accounts';
import { StatementOCR } from './statement-ocr';
import AngularView from './AngularView';
import createBackboneWrapper from './createBackboneWrapper';
import Error404 from './Error404';
import { loadReportingInterval, saveReportingInterval } from './reportingInterval';
import ledgerAccountsTabs from './ledger-accounts/ledgerAccountsTabs';
// $FlowFixMe - TS file
import ClientTasksApp from '../task-manager/client-task-manager/ClientTasksApp';
// $FlowFixMe - TS file
import AccountsPage from './accounts/AccountsPage';
import { useFeatureFlags } from '@bench/ff-client';
import { PageTitle } from 'bench-internal-theme';

type BkToolsRoutesProps = {
  clientId: string,
  patternPrefix: string,
};

type QueryParams = {
  [string]: any,
};

const squashQueryParams = (queryParams: QueryParams): QueryParams =>
  Object.keys(queryParams).reduce(
    (acc, key) => ({
      ...acc,
      [key]: queryParams[key] === '' || queryParams[key] === null ? undefined : queryParams[key],
    }),
    {},
  );

export default function BkToolsRoutes({ clientId, patternPrefix }: BkToolsRoutesProps) {
  const prefixClientIdToDocumentTitleText = documentTitle => `${clientId} - ${documentTitle}`;
  const [featureState] = useFeatureFlags();
  const {
    featureContext: { features },
  } = featureState;
  window.featureFlags = features;

  return (
    <Switch>
      <Redirect from={patternPrefix} exact to={`${patternPrefix}/new-dashboard/`} />
      <Route
        path={`${patternPrefix}/new-dashboard/`}
        render={() => {
          document.title = prefixClientIdToDocumentTitleText('Messages');
          return <AngularView clientId={clientId} viewName="new-dashboard" />;
        }}
      />
      <Route
        path={`${patternPrefix}/accounts/`}
        render={() => {
          document.title = prefixClientIdToDocumentTitleText('Accounts');
          return <AngularView clientId={clientId} viewName="accounts" />;
        }}
      />
      <Route
        path={`${patternPrefix}/new-accounts/`}
        render={() => {
          document.title = prefixClientIdToDocumentTitleText('Accounts');
          return <AccountsPage />;
        }}
      />
      <Route
        path={`${patternPrefix}/upload/:page?/:pathParams*`}
        render={createBackboneWrapper(prefixClientIdToDocumentTitleText('Upload'), UploadView)}
      />
      <Route
        path={`${patternPrefix}/new-folders/`}
        render={() => {
          document.title = prefixClientIdToDocumentTitleText('Folders');
          return <AngularView clientId={clientId} viewName="new-folders" />;
        }}
      />
      <Route
        path={`${patternPrefix}/statement-ocr`}
        render={({ history, location }) => {
          document.title = prefixClientIdToDocumentTitleText('Statement OCR');

          const parsedQueryParams = parse(location.search);
          const queryParams = {
            tab: undefined,
            ...parsedQueryParams,
          };

          const updateQueryParams = (queryParamsToUpdate: QueryParams) => {
            const updatedQueryParams = squashQueryParams({
              ...queryParams,
              ...queryParamsToUpdate,
            });

            history.replace({ search: stringify(updatedQueryParams) });
          };

          const { tab } = queryParams;

          return <StatementOCR tab={tab} updateQueryParams={updateQueryParams} />;
        }}
      />
      <Route
        path={`${patternPrefix}/ledger-accounts`}
        render={({ history, location }) => {
          document.title = prefixClientIdToDocumentTitleText('Ledger Accounts');

          const parsedQueryParams = parse(location.search);
          const queryParams = {
            search: '',
            showAccountsOnly: false,
            showActiveOnly: true,
            tab: undefined,
            ...parsedQueryParams,
          };

          const updateQueryParams = (queryParamsToUpdate: QueryParams) => {
            const updatedQueryParams = squashQueryParams({
              ...queryParams,
              ...queryParamsToUpdate,
            });

            if (updatedQueryParams.tab === ledgerAccountsTabs.ADDONS) {
              delete updatedQueryParams.showAccountsOnly;
              delete updatedQueryParams.showActiveOnly;
            }
            history.replace({ search: stringify(updatedQueryParams) });
          };

          const { search, tab, showAccountsOnly, showActiveOnly } = queryParams;

          return (
            <LedgerAccounts
              search={search}
              showAccountsOnly={showAccountsOnly === 'true'}
              showActiveOnly={showActiveOnly === 'true'}
              tab={tab}
              updateQueryParams={updateQueryParams}
            />
          );
        }}
      />
      <Route
        path={`${patternPrefix}/transaction-manager`}
        render={({ history, location }) => {
          document.title = prefixClientIdToDocumentTitleText('Transaction Manager');

          const parsedQueryParams = parse(location.search);
          const queryParams = {
            endDate: undefined,
            search: '',
            tab: undefined,
            startDate: undefined,
            ...parsedQueryParams,
          };

          const updateQueryParams = (queryParamsToUpdate: QueryParams) => {
            // Side-effect to support date ranges in legacy backbone & angular views
            if (queryParamsToUpdate.startDate && queryParamsToUpdate.endDate) {
              saveReportingInterval(clientId, queryParamsToUpdate);
            }
            const updatedQueryParams = squashQueryParams({
              ...queryParams,
              ...queryParamsToUpdate,
            });
            history.replace({ search: stringify(updatedQueryParams) });
          };

          const { search, tab } = queryParams;
          let reportingIntervalDateRange;
          if (queryParams.startDate && queryParams.endDate) {
            reportingIntervalDateRange = {
              startDate: queryParams.startDate,
              endDate: queryParams.endDate,
            };
          } else {
            const storedInterval = loadReportingInterval(clientId);
            if (storedInterval) {
              reportingIntervalDateRange = storedInterval.dateRange;
              updateQueryParams(storedInterval.dateRange);
            }
          }

          return (
            <TransactionManager
              dateRange={reportingIntervalDateRange}
              search={search}
              tab={tab}
              updateQueryParams={updateQueryParams}
            />
          );
        }}
      />
      <Route
        path={`${patternPrefix}/general-ledger-alpha`}
        render={({ history, location }) => {
          document.title = prefixClientIdToDocumentTitleText('General Ledger Alpha');

          const parsedQueryParams = parse(location.search);
          const queryParams = {
            endDate: undefined,
            search: '',
            showAccounts: false,
            showQualityIssues: true,
            sidebarElementId: undefined,
            sidebarType: undefined,
            startDate: undefined,
            ...parsedQueryParams,
          };

          const updateQueryParams = (queryParamsToUpdate: QueryParams) => {
            // Side-effect to support date ranges in legacy backbone & angular views
            if (queryParamsToUpdate.startDate && queryParamsToUpdate.endDate) {
              saveReportingInterval(clientId, queryParamsToUpdate);
            }
            const updatedQueryParams = squashQueryParams({
              ...queryParams,
              ...queryParamsToUpdate,
            });
            history.replace({ search: stringify(updatedQueryParams) });
          };

          const updateSidebarParams = (sidebarParams?: QueryParams) => {
            if (sidebarParams) {
              updateQueryParams(sidebarParams);
            } else {
              updateQueryParams({ sidebarElementId: undefined, sidebarType: undefined });
            }
          };

          let reportingIntervalDateRange;
          if (queryParams.startDate && queryParams.endDate) {
            reportingIntervalDateRange = {
              startDate: queryParams.startDate,
              endDate: queryParams.endDate,
            };
          } else {
            const storedInterval = loadReportingInterval(clientId);
            if (storedInterval) {
              reportingIntervalDateRange = storedInterval.dateRange;
              updateQueryParams(storedInterval.dateRange);
            }
          }
          const filters = {
            search: queryParams.search,
            showAccounts: queryParams.showAccounts === 'true',
            showQualityIssues: queryParams.showQualityIssues === 'true',
          };
          const sidebarDescriptor =
            !!queryParams.sidebarElementId && !!queryParams.sidebarType
              ? {
                  sidebarElementId: queryParams.sidebarElementId,
                  sidebarType: queryParams.sidebarType,
                }
              : undefined;

          return (
            <NewGeneralLedgerContainer
              clientId={clientId}
              dateRange={reportingIntervalDateRange}
              filters={filters}
              updateQueryParams={updateQueryParams}
              updateSidebarParams={updateSidebarParams}
              sidebarDescriptor={sidebarDescriptor}
            />
          );
        }}
      />
      <Route
        path={`${patternPrefix}/general-ledger`}
        render={({ history, location }) => {
          document.title = prefixClientIdToDocumentTitleText('General Ledger');

          const parsedQueryParams = parse(location.search);
          const queryParams = {
            endDate: undefined,
            search: '',
            showAccounts: false,
            showQualityIssues: true,
            sidebarElementId: undefined,
            sidebarType: undefined,
            startDate: undefined,
            ...parsedQueryParams,
          };

          const updateQueryParams = (queryParamsToUpdate: QueryParams) => {
            // Side-effect to support date ranges in legacy backbone & angular views
            if (queryParamsToUpdate.startDate && queryParamsToUpdate.endDate) {
              saveReportingInterval(clientId, queryParamsToUpdate);
            }
            const updatedQueryParams = squashQueryParams({
              ...queryParams,
              ...queryParamsToUpdate,
            });
            history.replace({ search: stringify(updatedQueryParams) });
          };

          const updateSidebarParams = (sidebarParams?: QueryParams) => {
            if (sidebarParams) {
              updateQueryParams(sidebarParams);
            } else {
              updateQueryParams({ sidebarElementId: undefined, sidebarType: undefined });
            }
          };

          let reportingIntervalDateRange;
          if (queryParams.startDate && queryParams.endDate) {
            reportingIntervalDateRange = {
              startDate: queryParams.startDate,
              endDate: queryParams.endDate,
            };
          } else {
            const storedInterval = loadReportingInterval(clientId);
            if (storedInterval) {
              reportingIntervalDateRange = storedInterval.dateRange;
              updateQueryParams(storedInterval.dateRange);
            }
          }
          const filters = {
            search: queryParams.search,
            showAccounts: queryParams.showAccounts === 'true',
            showQualityIssues: queryParams.showQualityIssues === 'true',
          };
          const sidebarDescriptor =
            !!queryParams.sidebarElementId && !!queryParams.sidebarType
              ? {
                  sidebarElementId: queryParams.sidebarElementId,
                  sidebarType: queryParams.sidebarType,
                }
              : undefined;

          return (
            <GeneralLedger
              clientId={clientId}
              dateRange={reportingIntervalDateRange}
              filters={filters}
              updateQueryParams={updateQueryParams}
              updateSidebarParams={updateSidebarParams}
              sidebarDescriptor={sidebarDescriptor}
            />
          );
        }}
      />
      <Route
        path={`${patternPrefix}/income-statement/:pathParams*`}
        render={createBackboneWrapper(
          prefixClientIdToDocumentTitleText('Income Statement'),
          IncomeStatementView,
        )}
      />
      <Route
        path={`${patternPrefix}/balance-sheet/:pathParams*`}
        render={createBackboneWrapper(
          prefixClientIdToDocumentTitleText('Balance Sheet'),
          BalanceSheetView,
        )}
      />
      <Route
        path={`${patternPrefix}/transactions/:pathParams*`}
        render={createBackboneWrapper(
          prefixClientIdToDocumentTitleText('Transactions'),
          TransactionsView,
        )}
      />
      <Route
        path={`${patternPrefix}/search/:pathParams*`}
        render={createBackboneWrapper(
          prefixClientIdToDocumentTitleText('Search Transactions'),
          SearchView,
        )}
      />
      <Route
        path={`${patternPrefix}/unmatched-receipts/:pathParams*`}
        render={createBackboneWrapper(
          prefixClientIdToDocumentTitleText('Unmatched Receipts'),
          UnmatchedReceiptsView,
        )}
      />
      <Route
        path={`${patternPrefix}/unmatched-receipts-search/:pathParams*`}
        render={createBackboneWrapper(
          prefixClientIdToDocumentTitleText('Search Unmatched Receipts'),
          UnmatchedReceiptsSearchView,
        )}
      />
      <Route
        path={`${patternPrefix}/excel-documents/:pathParams*`}
        render={createBackboneWrapper(
          prefixClientIdToDocumentTitleText('Excel Documents'),
          ExcelDocumentsView,
        )}
      />
      <Route
        path={`${patternPrefix}/download/:pathParams*`}
        render={createBackboneWrapper(prefixClientIdToDocumentTitleText('Download'), DownloadView)}
      />
      <Route
        path={`${patternPrefix}/details/`}
        render={() => {
          document.title = prefixClientIdToDocumentTitleText('Client Details');
          return <AngularView clientId={clientId} viewName="details" />;
        }}
      />
      <Route
        path={`${patternPrefix}/review-tool/`}
        render={({ location, history }) => {
          document.title = prefixClientIdToDocumentTitleText('Review Tool');

          const queryParams = parse(location.search);

          const persistState = queryParamsToUpdate => {
            const updatedQueryParams = squashQueryParams({
              ...queryParams,
              ...queryParamsToUpdate,
            });
            history.replace({ search: stringify(updatedQueryParams) });
          };

          return (
            <ReviewTool
              clientId={clientId}
              startDate={queryParams.startDate}
              endDate={queryParams.endDate}
              reviewing={queryParams.reviewing === 'true'}
              restoreLastChecks={queryParams.restoreLastChecks === 'true'}
              onReviewingChange={persistState}
            />
          );
        }}
      />
      <Route
        path={`${patternPrefix}/balance-checker/:pathParams*`}
        render={createBackboneWrapper(
          prefixClientIdToDocumentTitleText('Balance Checker'),
          BalanceCheckerView,
        )}
      />
      <Route
        path={`${patternPrefix}/document-entry/:pathParams*`}
        render={createBackboneWrapper(
          prefixClientIdToDocumentTitleText('Document Entry'),
          DocumentEntryView,
        )}
      />
      <Route
        path={`${patternPrefix}/reconciliation/:pathParams*`}
        render={createBackboneWrapper(
          prefixClientIdToDocumentTitleText('Reconciliation'),
          ReconciliationView,
        )}
      />
      <Route
        path={`${patternPrefix}/categorizer-rules/`}
        render={() => {
          document.title = prefixClientIdToDocumentTitleText('Categorizer Rules');
          return <AngularView clientId={clientId} viewName="categorizer-rules" />;
        }}
      />
      <Route
        path={`${patternPrefix}/new-ledgers/`}
        render={() => {
          document.title = prefixClientIdToDocumentTitleText('Ledger Accounts');
          return <AngularView clientId={clientId} viewName="new-ledgers" />;
        }}
      />
      <Route
        path={`${patternPrefix}/import-excel/:pathParams*`}
        render={createBackboneWrapper(
          prefixClientIdToDocumentTitleText('Import From Excel'),
          ImportExcelView,
        )}
      />
      <Route
        path={`${patternPrefix}/task-manager`}
        render={() => (
          <>
            <PageTitle title="Client Task Manager" />
            <ClientTasksApp clientId={clientId} />
          </>
        )}
      />
      <Route component={Error404} />
    </Switch>
  );
}
